import { lazy, Suspense } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { ReloadRouteObserver } from 'src/lib/perf/ReloadRouteObserver.component';
import Agenda from '../../pages/Agenda/Agenda.page.tsx';
import AuthMiddleware from '../AuthMiddleware/AuthMiddleware.component.tsx';
import { RouterPaths } from './Router.constants.ts';
import { VITE_TIKTOK_FEATURE } from '../../constants/envs';
import { LEAD_AGENT_DASHBOARD_AUDIENCE } from './leadAgentDashboardAudience';

const WhatsappApi = lazy(
  () => import('../../pages/WhatsappApi/WhatsappApi.page.tsx'),
);
const TikTok = lazy(
  () => import('../../pages/TikTok/TikTok.page.tsx'),
);
const Assistant = lazy(() => import('../../pages/Assistant/Assistant.page.tsx'));
const Analytics = lazy(
  () => import('../../pages/Analytics/Analytics.page.tsx'),
);
const AccountRecovery = lazy(
  () => import('../../pages/Auth/AccountRecovery/AccountRecovery.page.tsx'),
);
const CreateWorkspacePage = lazy(
  () => import('../../pages/Auth/CreateWorkspace/CreateWorkspace.page.tsx'),
);
const SignIn = lazy(() => import('../../pages/Auth/SignIn/SignIn.page.tsx'));
const SignUp = lazy(() => import('../../pages/Auth/SignUp/SignUp.page.tsx'));
const Activate = lazy(
  () => import('../../pages/Auth/Activate/Activate.page.tsx'),
);
const ChatPage = lazy(
  () => import('../../pages/MessengerV2/Messenger.page.tsx'),
);
const InboxPage = lazy(() => import('../../pages/Inbox/Inbox.page.tsx'));
const DashboardPage = lazy(
  () => import('../../pages/Dashboard/Dashboard.page.tsx'),
);
const Directory = lazy(
  () => import('../../pages/Directory/Directory.page.tsx'),
);
const LeadBot = lazy(() => import('../../pages/LeadBot/LeadBot.page.tsx'));
const SmartConfigRoute = lazy(() => import('./SmartConfigRoute.component.tsx'));
const LeadClick = lazy(
  () => import('../../pages/LeadClick/LeadClick.page.tsx'),
);
const Pipe = lazy(() => import('../../pages/Pipe/Pipe.page.tsx'));
const Settings = lazy(() => import('../../pages/Settings/Settings.page.tsx'));
const DevErrorCatalog = lazy(
  () => import('../../pages/DevErrorCatalog/DevErrorCatalog.page.tsx'),
);
const Onboarding = lazy(
  () => import('../../pages/Onboarding/Onboarding.component.tsx'),
);

export default function Router() {
  return (
    <Suspense>
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route element={<AuthMiddleware />}>
          <Route element={<ReloadRouteObserver><Outlet /></ReloadRouteObserver>}>
          <Route path={RouterPaths.signIn} element={<SignIn />} />
          <Route path={RouterPaths.signUp} element={<SignUp />} />
          <Route path={RouterPaths.activate} element={<Activate />} />
          <Route
            path={RouterPaths.createWorkspace}
            element={<CreateWorkspacePage />}
          />
          <Route
            path={RouterPaths.accountRecovery}
            element={<AccountRecovery />}
          />

          {/* PRIVATE ROUTES */}
          <Route path={RouterPaths.dashboard} element={<DashboardPage />} />
          <Route path={RouterPaths.funnels} element={<Pipe />} />
          <Route path={RouterPaths.chat} element={<ChatPage />} />
          <Route path={RouterPaths.agenda} element={<Agenda />} />
          <Route path={RouterPaths.directory} element={<Directory />} />
          <Route path={RouterPaths.analytics} element={<Analytics />} />
          <Route path={RouterPaths.assistant} element={<Assistant />} />
          <Route path={RouterPaths.wapi} element={<WhatsappApi />} />
          <Route path={RouterPaths.smartLeadbotConfig} element={<SmartConfigRoute audience={LEAD_AGENT_DASHBOARD_AUDIENCE} />} />
          {VITE_TIKTOK_FEATURE && (
            <Route path={RouterPaths.tiktok} element={<TikTok />} />
          )}
          <Route path={RouterPaths.leadbot} element={<LeadBot />} />
          <Route path={RouterPaths.alertCenter} element={<InboxPage />} />
          <Route path={RouterPaths.leadclick} element={<LeadClick />} />
          <Route path={RouterPaths.settings} element={<Settings />} />
          <Route path={RouterPaths.onboarding} element={<Onboarding />} />

          {import.meta.env.MODE === 'development' && (
            <Route path="/dev/error-catalog" element={<DevErrorCatalog />} />
          )}
          </Route>

          <Route
            path="*"
            element={<Navigate to={RouterPaths.dashboard} replace />}
          />
        </Route>
      </Routes>
    </Suspense>
  );
}
